/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { Fragment } from 'react'

import { EuiSpacer, EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { PlatformInfo } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'
import { CuiAlert } from '@modules/cui/Alert'

import PlatformVersion from './PlatformVersion'
import PlatformAdminServersStatus from './PlatformAdminServersStatus'

interface Props {
  fetchPlatform: () => Promise<any>
  regionId: string
  platform: PlatformInfo | null
  fetchPlatformRequest: AsyncRequestState
}

const Platform: React.FC<Props> = ({ regionId, platform, fetchPlatformRequest }) => {
  const renderContent = () => {
    if (fetchPlatformRequest.error) {
      return <CuiAlert type='error'>{fetchPlatformRequest.error}</CuiAlert>
    }

    return (
      <Fragment>
        <PlatformVersion platform={platform} />

        <EuiSpacer size='l' />

        <PlatformAdminServersStatus regionId={regionId} platform={platform} />
      </Fragment>
    )
  }

  return (
    <Fragment>
      <EuiTitle size='s'>
        <h2>
          <FormattedMessage
            id='region-admin-platform.system-information'
            defaultMessage='System information'
          />
        </h2>
      </EuiTitle>

      <EuiSpacer size='m' />

      {renderContent()}
    </Fragment>
  )
}

export default Platform
